module.exports = __webpack_public_path__ + "static/Arnav-366fce49deb0207e1da82b4c2e4dea9b.jpg";